import styled from 'styled-components';

import { Container } from '../BackgroundLocationRequiredModal/styles';

/**
 * El contenedor del de segundo plano, pero con techo y desplazamiento: con el
 * aviso de «opción mala» y los tres pasos de Ajustes, en una tablet en
 * HORIZONTAL el modal no cabía y el botón quedaba fuera de la pantalla (visto
 * en la Tab Active5 el 25-09-2026). Con el botón fuera, un modal bloqueante
 * es una cárcel.
 */
export const ScrollableContainer = styled(Container)`
  max-height: calc(100vh - 4rem);
  max-height: calc(100dvh - 4rem);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

/**
 * Pasos numerados, centrados como el resto del modal y con el número pegado
 * al texto («1. Pulsa…»).
 *
 * 🔴 `list-style` hay que ponerlo a mano: `global-styles.ts` resetea
 * `ol, ul { list-style: none }` y sin esto los números no se pintan (la
 * primera versión salió sin ellos en la tablet).
 */
export const Steps = styled.ol`
  margin: 0;
  padding: 0;
  list-style: decimal inside;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  font-family: 'Poppins', sans-serif;
  font-size: ${({ theme }) => theme.fontSize.M};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
`;

/**
 * Solo aparece si el operario eligió la opción que no sirve (ubicación
 * aproximada o «Permitir acceso limitado»): se le dice qué pasó en ese
 * momento, en vez de nombrarle de antemano la opción que no sirve. Fondo gris
 * suave para separarlo de la opción destacada (granate).
 */
export const Notice = styled.p`
  margin: 0;
  align-self: stretch;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: ${({ theme }) => theme.fontSize.S};
  padding: ${({ theme }) => theme.spaces.s}rem
    ${({ theme }) => theme.spaces.m}rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
  color: ${({ theme }) => theme.colors.black};
`;
